/* eslint-disable react/display-name */
import { Card, CardContent, IconButton, Tooltip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import PrintIcon from "@mui/icons-material/Print";
import Grid from "@mui/material/Grid";
import PSelect from "../../components/pos/PSelect";
import PText from "../../components/pos/PText";
import db from "../../db/db";
import MUIDataTable from "mui-datatables";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import API from "../../utils/API";
import { StringUtils } from "../../utils/StringUtils";
import BarcodePrintView from "./BarcodePrintView";
import ProductPricingMoreActions from "./product-more-actions/ProductPricingMoreActions";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { PricingUtils } from "../../utils/PricingUtils";
import { Store } from "../../utils/Store";
import Popover from "@mui/material/Popover";

export default function ProductPricing(props) {
  const { t } = useTranslation();
  const translate = t;
  const [barcodeForPrint, setBarcodeForPrint] = useState();
  const [printBarcodeFormatOptions, setPrintBarcodeFormatOptions] = useState(
    []
  );
  const [printShelfFormatOptions, setPrintShelfFormatOptions] = useState([]);
  const [selectedDept, setSelectedDept] = useState(false);
  const [showBarcodePrintWindow, setShowBarcodePrintWindow] = useState(false);
  const [priceColumnCustomHeadLabel, setPriceColumnCustomHeadLabel] =
    useState("Price w/o Tax & %");
  props.biRef.child = {
    parentEvent: parentEvent,
  };
  const [pricingSummary, setPricingSummary] = useState({
    margin: "0.0",
    actualPrice: "0.0",
    promotionAmount: "0.0",
    taxAmount: "0.0",
    salePrice: "0.0",
    cost: "0.0",
  });
  const [summaryViewElement, setSummaryViewElement] = useState(null);
  const [summaryViewOpen, setSummaryViewOpen] = useState(false);

  var biRef = {};

  useEffect(() => {
    populatePrintFormat(0, 100, "[]", "[]");
  }, []);

  useEffect(() => {
    setPriceColumnCustomHeadLabel(getPriceLabel(props.incTax, props.incDisc));
    //TODO

    let datList = [...props.pricingData];
    for (let i = 0; i < datList.length; i++) {
      console.log(datList[i]);
      updatevalues(datList[i], "PRICE", datList[i][5], 5);
    }

    props.setPricingData(datList);
  }, [props.incTax]);

  useEffect(() => {
    setPriceColumnCustomHeadLabel(getPriceLabel(props.incTax, props.incDisc));
  }, [props.incDisc]);

  async function populatePrintFormat(curPage, pageSize, sort, filter) {
    const result = await API.get(
      "/api/v1/configs?range=" +
        encodeURIComponent(
          "[" + curPage * pageSize + "," + ((curPage + 1) * pageSize - 1) + "]"
        ) +
        "&filter=" +
        encodeURIComponent(filter) +
        "&sort=" +
        encodeURIComponent(sort)
    );
    let printBarcodeFormats = [];
    let printShelfFormats = [];
    for (let i = 0; i < result.data.length; i++) {
      if (result.data[i].name.includes("BARCODE"))
        printBarcodeFormats.push({
          name: result.data[i].name,
          value: result.data[i],
        });
      if (result.data[i].name.includes("SHELF"))
        printShelfFormats.push({
          name: result.data[i].name,
          value: result.data[i],
        });
    }
    setPrintBarcodeFormatOptions(printBarcodeFormats);
    setPrintShelfFormatOptions(printShelfFormats);
  }

  const valType = [
    "UNTI_TYPE",
    "FACTOR",
    "COST",
    "MARGIN_PER",
    "MARGIN",
    "PRICE",
    "BARCODES",
    "PROMOTIONS",
    "PRICE_CARD",
    "INC_TAX_IN_PRICE",
    "INC_DISC_IN_PRICE",
  ];

  /*const unitTypeOptions = [
    { name: "EACH" },
    { name: "PACK" },
    { name: "CARTON" },
    { name: "BUNDLE" },
    { name: "KG" },
    { name: "PCS" },
  ];*/
  function getPriceLabel(iTax, iDisc) {
    let label = "Price";
    if (iTax) {
      if (iDisc) {
        label = translate("Price with Tax & %");
      } else {
        label = translate("Price with Tax ");
      }
    } else {
      if (iDisc) {
        label = translate("Price with % ");
      } else {
        label = translate("Price w/o Tax & %");
      }
    }
    return label;
  }

  function updatePricingLabel(columnHeader) {
    let datList = [...props.pricingData];
    if (datList && datList.length > 0) {
      datList[0]["info"] = { pricingLabel: columnHeader };
      props.setPricingData(datList);
    }
  }

  function parentEvent(eventType, value, value1, value2) {
    if ("includeTaxInPrice" === eventType) {
      //setIncTax(value);
      //updatePricingLabel(getPriceLabel(value, incDisc));
      //updateData("crud", null, value, 9);
    } else if ("includeDicountinprice" === eventType) {
      // setIncDisc(value);
      //updateData("crud", null, value, 10);
      //updatePricingLabel(getPriceLabel(incTax, value));
    } else if ("validate" === eventType) {
      getProductPricingBeanList();
      return validate();
    } else if ("validateBarcodes" === eventType) {
      return validateBarcodes(value);
    } else if ("getProductPricingBeanList" === eventType) {
      return getProductPricingBeanList();
    } else if ("facePrice" === eventType) {
      return facePrice();
    } else if ("renderServerValidation" === eventType) {
      return renderServerValidation(value);
    } /*else if ("configureColumns" === eventType) {
      configureColumns(value);
    }*/
  }

  function renderServerValidation(errMsg) {}

  function facePrice() {}

  function facePriceIncTax() {}

  function getProductPricingBeanList() {}

  function validateBarcodes(itemCode) {}

  function validate() {}

  function generateAutoBarcode(tableMeta) {
    if (
      props.deptId != null &&
      props.deptId != undefined &&
      props.deptId != ""
    ) {
      setAutoBarcodeFromDeptId(props.deptId, tableMeta);
    } else {
      props.showMessage(
        "error",
        translate(
          "Department is empty, Please select any department for generate barcode"
        )
      );
    }
  }

  async function setAutoBarcodeFromDeptId(deptObj, tableMeta) {
    console.log("generating Barcode");
    let dbData = await db.product.where("deptId").equals(deptObj.id).toArray();

    //DOuble Check the Logic
    let loop = 0;
    let newCode = "";
    while (loop >= 0) {
      console.log("Earching for barcode loop " + loop);
      newCode = zeroFill(
        deptObj.code +
          (tableMeta.rowIndex + 1).toString() +
          (dbData.length + 11111 + loop).toString(),
        12
      );
      let prodData = await db.product
        .where("barcodeList")
        .equals(newCode)
        .toArray();

      if (prodData.length == 0) {
        break;
      } else {
        loop++;
      }
    }

    let barcodes = [];
    barcodes.push(newCode);
    updateData("table", tableMeta, { v: barcodes });
  }

  function zeroFill(code, width) {
    width -= code.length;
    if (width > 0) {
      return code + new Array(width + (/\./.test(code) ? 2 : 1)).join("0");
    }
    return code + ""; // always return a string
  }

  async function getCostByUnitType(productBean, unitType, defaultCost) {
    for (let i = 0; i < productBean.productPricingBeanList.length; i++) {
      if (productBean.productPricingBeanList[i].unitType == unitType) {
        return productBean.productPricingBeanList[i].cost;
      }
    }
    return defaultCost;
  }

  async function populatePricingSummary(rowData) {
    let decimal = props.context.store.currencyDecimal;
    let cost = rowData[2] ? rowData[2].v : 0;
    let price = rowData[5] ? rowData[5].v : 0;
    let marginPerCentage = rowData[3] ? rowData[3].v : 0;
    let derivedCost = await getCostByUnitType(
      props.origObject,
      rowData[0].v.code,
      cost
    );
    let result = PricingUtils.derivePrice(
      decimal,
      derivedCost,
      price,
      rowData[8].info.incTax,
      props.taxId ? props.taxId.rate : 0,
      0,
      rowData[8].info.incDisc,
      [],
      false,
      1
    );
    console.log(
      "PRICE P",
      decimal,
      derivedCost,
      price,
      rowData[8].info.incTax,
      props.taxId ? props.taxId.rate : 0,
      0,
      rowData[8].info.incDisc,
      [],
      false,
      1
    );
    console.log("PRICE R", result);
    setPricingSummary({
      margin: result.margin,
      actualPrice: result.price,
      promotionAmount: result.promotionAmount,
      taxAmount: result.taxAmount,
      salePrice: result.retailSalePrice,
      cost: derivedCost,
      marginPerCentage: marginPerCentage,
    });
  }

  const handleClose = () => {
    setSummaryViewOpen(!summaryViewOpen);
    setSummaryViewElement(null);
  };

  function calculateCostWithTax(cost) {
    if (!cost) return 0;
    if (props.taxId && props.taxId.rate && parseFloat(cost) > 0) {
      let taxPercentage = props.taxId.rate;
      let taxCost = StringUtils.formattedNumber(
        parseFloat(cost) + (cost * parseFloat(taxPercentage)) / 100,
        props.context.store.currencyDecimal
      );
      return taxCost;
    } else {
      return cost;
    }
  }

  const priceColumns = [
    {
      name: "unitType",
      label: translate("Unit Type"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        noWrap: true,
        /* eslint-disable react/display-name */
        customBodyRender: (value, tableMeta, updateValue) => (
          /* tableMeta.rowIndex == 0 ? (
            <div style={{ width: 110 }}>
              <PText
                readOnly={true}
                value={value.v.name}
                errorMessage={value.e}
                onFocus={(e) => {
                  let tempData = [...tableMeta.tableData];
                  props.populatePricingSummary(tempData[tableMeta.rowIndex]);
                }}
                onBlur={(e) => props.setShowPricingSummary(false)}
                onChange={(e) => updateData("table", tableMeta, e.target.value)}
                InputProps={{
                  readOnly: true,
                }}
                disabled={true}
              ></PText>
            </div>
          ) : (*/
          <div style={{ width: 200 }}>
            <PSelect
              options={props.unitTypeOptions}
              value={value.v}
              errorMessage={value.e}
              onChange={(event, newValue) => {
                updateData(
                  "table",
                  tableMeta,
                  newValue
                    ? {
                        v: { name: newValue.name, code: newValue.code },
                        e: "",
                      }
                    : { v: { name: "", code: "" }, e: "" }
                );
              }}
            ></PSelect>
          </div>
        ),
        // ),
      },
    },
    {
      name: "factor",
      label: translate("Factor"),
      options: {
        filter: false,
        sort: false,
        display: props.productType == "R" ? false : true,
        customBodyRender: (value, tableMeta, updateValue) => (
          <div>
            <PText
              value={value.v}
              type="number"
              error={value.e}
              onChange={(e) =>
                updateData(
                  "table",
                  tableMeta,
                  e.target.value
                    ? { v: e.target.value, e: "" }
                    : { v: "", e: "" }
                )
              }
              InputProps={{
                readOnly: tableMeta.rowIndex == 0 ? true : false,
              }}
              disabled={tableMeta.rowIndex == 0}
            ></PText>
          </div>
        ),
      },
    },
    {
      name: "cost",
      label: translate("Cost without & with Tax"),
      options: {
        filter: false,
        sort: false,
        display: !props.context.privileges.edit_product ? "false" : "true",

        customBodyRender: (value, tableMeta, updateValue) => (
          <div>
            <table width="100%">
              <tr>
                <td>
                  <PText
                    value={value.v}
                    type="number"
                    onChange={(e) =>
                      updateData(
                        "table",
                        tableMeta,
                        e.target.value
                          ? { v: e.target.value, e: "" }
                          : { v: "", e: "" }
                      )
                    }
                    InputProps={{
                      readOnly:
                        props.storeAdminSetting &&
                        props.storeAdminSetting.enableAccounting
                          ? true
                          : false,
                    }}
                  ></PText>
                </td>
                <td>
                  <PText
                    value={calculateCostWithTax(value.v)}
                    type="number"
                    InputProps={{
                      readOnly: true,
                    }}
                  ></PText>
                </td>
              </tr>
            </table>
          </div>
        ),
      },
    },
    {
      name: "marginPer",
      label: translate("Margin %"),
      options: {
        filter: false,
        sort: false,
        display: "true",

        customBodyRender: (value, tableMeta, updateValue) => (
          <div>
            <PText
              value={value.v}
              type="number"
              onChange={(e) =>
                updateData(
                  "table",
                  tableMeta,
                  e.target.value
                    ? { v: e.target.value, e: "" }
                    : { v: "", e: "" }
                )
              }
            ></PText>
          </div>
        ),
      },
    },
    {
      name: "margin",
      label: translate("Margin"),
      options: {
        filter: false,
        sort: false,
        display: "true",

        customBodyRender: (value, tableMeta, updateValue) => (
          <div>
            <PText
              value={value.v}
              type="number"
              onChange={(e) =>
                updateData(
                  "table",
                  tableMeta,
                  e.target.value
                    ? { v: e.target.value, e: "" }
                    : { v: "", e: "" }
                )
              }
            ></PText>
          </div>
        ),
      },
    },
    {
      name: "priceWithTax",
      label: priceColumnCustomHeadLabel,
      options: {
        filter: false,
        sort: false,
        display: "true",

        customBodyRender: (value, tableMeta, updateValue) => (
          <div>
            <PText
              value={value.v}
              type="number"
              onChange={(e) =>
                updateData(
                  "table",
                  tableMeta,
                  e.target.value
                    ? { v: e.target.value, e: "" }
                    : { v: "", e: "" }
                )
              }
            ></PText>
          </div>
        ),
      },
    },
    {
      name: "barcodes",
      label: translate("Barcodes"),
      options: {
        filter: false,
        sort: false,
        display: "true",

        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: "200px" }}>
            <table width="100%">
              <tbody>
                <tr>
                  <td width="95%">
                    <PText
                      value={value.v.length > 0 ? value.v[0] : ""}
                      error={value.e}
                      onChange={(e) => {
                        let tempPricingData = [...tableMeta.tableData];
                        let barcodes = tempPricingData[tableMeta.rowIndex][6].v;
                        if (barcodes.length > 0) {
                          barcodes[0] = e.target.value;
                        } else {
                          barcodes.push(e.target.value);
                        }
                        tempPricingData[tableMeta.rowIndex][6].v = barcodes;
                        props.setPricingData(tempPricingData);
                      }}
                    ></PText>
                  </td>
                  {(value.v.length == 0 || value.v[0] === "") && (
                    <td width="5%">
                      <Tooltip title={"Generate auto barcode"}>
                        <IconButton
                          aria-label="close"
                          onClick={() => {
                            generateAutoBarcode(tableMeta);
                          }}
                        >
                          <AddIcon />
                        </IconButton>
                      </Tooltip>
                    </td>
                  )}
                </tr>
              </tbody>
            </table>
          </div>
        ),
      },
    },
    {
      name: "",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: "true",
        customHeadLabelRender: (value, tableMeta, updateValue) => {
          return (
            <div>
              <table width="100%">
                <tr>
                  <td align="right">Action</td>
                  <td align="right">
                    {props.context.privileges.edit_product && (
                      <Tooltip title={"Add new row"}>
                        <IconButton
                          color="secondary"
                          onClick={addProductPricing}
                        >
                          <AddIcon />
                        </IconButton>
                      </Tooltip>
                    )}
                  </td>
                </tr>
              </table>
            </div>
          );
        },
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ textAlign: "center" }}>
            <table>
              <tr>
                {props.opType === "edit" && (
                  <td>
                    <Tooltip title={"Print Barcode"}>
                      <IconButton
                        color="primary"
                        onClick={() => {
                          let tempData = [...tableMeta.tableData];
                          if (
                            tempData[tableMeta.rowIndex][6].v != null &&
                            tempData[tableMeta.rowIndex][6].v != undefined &&
                            tempData[tableMeta.rowIndex][6].v.length > 0
                          ) {
                            setBarcodeForPrint(tempData[tableMeta.rowIndex]);
                            setShowBarcodePrintWindow(true);
                          } else
                            props.showMessage(
                              "error",
                              "No barcode found for print"
                            );
                        }}
                      >
                        <PrintIcon />
                      </IconButton>
                    </Tooltip>
                  </td>
                )}
                {props.context.privileges.edit_product && (
                  <td>
                    <Tooltip title={"Pricing Summary"}>
                      <IconButton
                        color="primary"
                        onClick={(event) => {
                          let tempData = [...tableMeta.tableData];
                          populatePricingSummary(tempData[tableMeta.rowIndex]);
                          setSummaryViewElement(event.currentTarget);
                          setSummaryViewOpen(true);
                        }}
                      >
                        <InfoOutlinedIcon />
                      </IconButton>
                    </Tooltip>
                    <Popover
                      open={summaryViewOpen}
                      anchorEl={summaryViewElement}
                      onClose={handleClose}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left",
                      }}
                    >
                      <Card style={{ marginTop: 5 }}>
                        <CardContent style={{ backgroundColor: "#f5f4f2" }}>
                          <table width="100%">
                            <tbody>
                              <tr>
                                <td>{translate("Costing method")}</td>
                                <td>:</td>
                                <td style={{ paddingLeft: "10px" }}>
                                  {props.storeAdminSetting &&
                                  props.storeAdminSetting.costingMethodeName
                                    ? props.storeAdminSetting.costingMethodeName
                                    : "Average"}
                                </td>
                              </tr>
                              <tr>
                                <td>{translate("Cost derived")}</td>
                                <td>:</td>
                                <td style={{ paddingLeft: "10px" }}>
                                  {StringUtils.formattedNumber(
                                    pricingSummary.cost,
                                    props.context.store.currencyDecimal
                                  )}
                                </td>
                              </tr>
                              <tr>
                                <td>{translate("Price without tax")}</td>
                                <td>:</td>
                                <td style={{ paddingLeft: "10px" }}>
                                  {StringUtils.formattedNumber(
                                    pricingSummary.actualPrice,
                                    props.context.store.currencyDecimal
                                  )}
                                </td>
                              </tr>
                              <tr>
                                <td>{translate("Retail sale price")}</td>
                                <td>:</td>
                                <td style={{ paddingLeft: "10px" }}>
                                  {StringUtils.formattedNumber(
                                    pricingSummary.salePrice,
                                    props.context.store.currencyDecimal
                                  )}
                                </td>
                              </tr>
                              <tr>
                                <td>{translate("Tax amount [RSP x Tax%]")}</td>
                                <td>:</td>
                                <td style={{ paddingLeft: "10px" }}>
                                  {StringUtils.formattedNumber(
                                    pricingSummary.taxAmount,
                                    props.context.store.currencyDecimal
                                  )}
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  {translate("Margin amount [RSP-Cost-Tax]")}
                                </td>
                                <td>:</td>
                                <td style={{ paddingLeft: "10px" }}>
                                  {StringUtils.formattedNumber(
                                    pricingSummary.margin,
                                    props.context.store.currencyDecimal
                                  )}
                                </td>
                              </tr>
                              <tr>
                                <td>{translate("Margin %")}</td>
                                <td>:</td>
                                <td style={{ paddingLeft: "10px" }}>
                                  {StringUtils.formattedNumber(
                                    pricingSummary.marginPerCentage,
                                    props.context.store.currencyDecimal
                                  )}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </CardContent>
                      </Card>
                    </Popover>
                  </td>
                )}
                {props.context.privileges.edit_product && (
                  <td>
                    <Tooltip title={"Pricing actions"}>
                      <IconButton
                        color="primary"
                        onClick={() => {
                          biRef.pricingMoreActions.showProductPricingMoreActions(
                            tableMeta
                          );
                        }}
                      >
                        <MenuOutlinedIcon />
                      </IconButton>
                    </Tooltip>
                  </td>
                )}
                {props.context.privileges.edit_product &&
                  tableMeta.rowIndex > 0 && (
                    <Tooltip title={"Remove pricing"}>
                      <IconButton
                        color="secondary"
                        onClick={() =>
                          onDeleteClicked(tableMeta, updateValue, value)
                        }
                      >
                        <CloseIcon />
                      </IconButton>
                    </Tooltip>
                  )}
              </tr>
            </table>
          </div>
        ),
      },
    },
  ];

  function updateData(eventSource, meta, value, index) {
    if (eventSource === "table") {
      let dat = [...meta.tableData];
      updatevalues(
        dat[meta.rowIndex],
        valType[meta.columnIndex],
        value,
        meta.columnIndex
      );
      // configureColumns(dat.length);
      props.setPricingData(dat);
    }
    if (eventSource === "crud") {
      let datList = [...props.pricingData];
      for (let i = 0; i < datList.length; i++) {
        updatevalues(datList[i], valType[index], value, index);
      }

      props.setPricingData(datList);
    }
  }
  function updatevalues(rowData, valType, value, colIndex) {
    rowData[colIndex] = value;

    let cost = 0;
    let margin = 0;
    let marginPer = 0;
    let price = 0;
    let priceWoTax = 0;

    let promotion = 0;
    let priceAfterPromotion;
    let taxAmount = 0;

    console.log("ROW", rowData);

    if (rowData[2]) cost = rowData[2].v;
    if (rowData[5]) {
      price = rowData[5].v;

      //let preTax=price – (price / (1 + props.taxId.rate) * props.taxId.rate)

      priceWoTax = rowData[8].info.incTax
        ? price / (1 + props.taxId.rate / 100)
        : price;
      console.log("Price without tax", priceWoTax);
    }
    if (rowData[3]) marginPer = rowData[3].v;
    if (rowData[4]) margin = rowData[4].v;
    /*if(valType=="PROMOTIONS")
    {

    }else */
    if (valType == "COST") {
      if (price) {
        cost = value.v;
        if (price && price > 0 && cost && cost > 0) {
          margin = priceWoTax - cost;
          marginPer = (margin / cost) * 100;
        } else {
          margin = 0;
          marginPer = 0;
        }
      }
    } else if (valType == "MARGIN") {
      margin = value.v;
      if (cost && cost > 0) {
        marginPer = (parseFloat(margin) / parseFloat(cost)) * 100;
        price = parseFloat(cost) + parseFloat(margin);
        if (rowData[8].info.incTax) {
          price = price + price * (props.taxId.rate / 100);
        }
      }
    } else if (valType == "MARGIN_PER") {
      marginPer = value.v;
      if (cost && cost > 0) {
        margin = parseFloat(cost) * (marginPer / 100);
        price = parseFloat(cost) + margin;
        if (rowData[8].info.incTax) {
          price = price + price * (props.taxId.rate / 100);
        }
      }
    } else if (valType == "PRICE") {
      //price = value.v;
      if (cost && cost > 0 && price && price > 0) {
        margin = priceWoTax - cost;
        marginPer = (margin / cost) * 100;
      } else {
        margin = 0;
        marginPer = 0;
      }
    }

    updatePriceOnScreen(valType, rowData, cost, margin, marginPer, price);
  }

  function updatePriceOnScreen(
    valType,
    rowData,
    cost,
    margin,
    marginPer,
    price,
    incTaxInPrice,
    incDiscInPrice
  ) {
    setVal(rowData, 2, cost, valType, "COST");
    setVal(rowData, 3, marginPer, valType, "MARGIN_PER");
    setVal(rowData, 4, margin, valType, "MARGIN");
    setVal(rowData, 5, price, valType, "PRICE");
    //refreshCard(rowData, props.incTax, props.incDisc);
  }

  // function refreshCard(rowData, incTax, incDisc) {
  //   console.log("FFC-", rowData, incTax);
  //   let decimal = Store.get("decimal");
  //   let cost = rowData[2] ? rowData[2].v : 0;
  //   let price = rowData[5] ? rowData[5].v : 0;
  //   //let incTax = rowData[10] ? rowData[10].v : false;
  //   //let incDisc = rowData[11] ? rowData[11].v : false;
  //   let result = PricingUtils.derivePrice(
  //     decimal,
  //     cost,
  //     price,
  //     incTax,
  //     5,
  //     0,
  //     incDisc,
  //     [],
  //     false,
  //     1
  //   );
  //   rowData[8] = {
  //     marginOnRsp: result.margin,
  //     priceExPromotionExTax: result.price,
  //     promotionAmount: result.promotionAmount,
  //     taxAmount: result.taxAmount,
  //     priceRsp: result.retailSalePrice,
  //   };

  //   //props.populatePricingSummary(rowData);
  // }

  function setVal(rowData, index, value, valType, dataType) {
    if (valType === dataType) {
      rowData[index] = { v: value, e: "" };
    } else {
      if (isFinite(value)) {
        rowData[index] = {
          v: StringUtils.formattedNumber(
            value,
            props.context.store.currencyDecimal
          ),
          e: "",
        };
      } else {
        rowData[index] = { v: "", e: "" };
      }
    }
  }

  function onDeleteClicked(tableMeta, updateValue, value) {
    let dat = [...tableMeta.tableData];
    dat.splice(tableMeta.rowIndex, 1);
    props.setPricingData(dat);
  }

  const options = {
    filterType: "checkbox",
    search: false,
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    pagination: false,
    selectableRows: "false",
    tableBodyMaxHeight: "100%",
    tableBodyHeight: 280,
    /*onTableChange: (action, tableState) => {
      if ("viewColumnsChange" === action) {
        updateColumns(tableState.columns);
      }
    },*/
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
  };

  function onEditClicked(value) {}

  function addProductPricing() {
    let dat = [...props.pricingData];
    dat.push([
      { v: { name: "", code: "" }, e: "" },
      { v: "0", e: "" },
      { v: "0", e: "" },
      { v: "0", e: "" },
      { v: "0", e: "" },
      { v: "0", e: "" },
      { v: [], e: "" },
      { o: props.promotionOptions, v: [], e: "" },
      {
        marginOnRsp: 0,
        info: { incTax: props.incTax, incDisc: props.incDisc },
      },
      null,
      props.incTax,
      props.incDisc,
      {},
      [],
      props.pricingLevels,
      [] /*ingredientsList*/,
    ]);

    //dat[meta.rowIndex][meta.columnIndex] = value;
    props.setPricingData(dat);
  }

  return (
    <Grid container>
      <Grid item xs={12}>
        <MUIDataTable
          data={props.pricingData}
          columns={priceColumns}
          options={options}
        />
      </Grid>
      {showBarcodePrintWindow && (
        <BarcodePrintView
          biRef={biRef}
          showMessage={props.showMessage}
          setAlert={props.setAlert}
          context={props.context}
          barcodeForPrint={barcodeForPrint}
          origObject={props.origObject}
          printBarcodeFormatOptions={printBarcodeFormatOptions}
          printShelfFormatOptions={printShelfFormatOptions}
          setShowBarcodePrintWindow={setShowBarcodePrintWindow}
          showProgress={props.showProgress}
          hideProgress={props.hideProgress}
          setProgressMessage={props.setProgressMessage}
        ></BarcodePrintView>
      )}
      <ProductPricingMoreActions
        biRef={biRef}
        setPricingData={props.setPricingData}
        showMessage={props.showMessage}
        context={props.context}
        deptId={props.deptId}
        origObject={props.origObject}
        productType={props.productType}
      ></ProductPricingMoreActions>
    </Grid>
  );
}
